import React, { useEffect, useState } from 'react';
import axios from 'axios';

const VideoGallery = () => {
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const response = await axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_latest_testimonials.php');
                setVideos(response.data);
            } catch (error) {
                console.error('Error fetching videos:', error);
            }
        }; 

        fetchVideos();
    }, []);

    return (
        <div className="insight-video-gallery">
            {videos.map(video => (
                <div key={video.id} className="video-item">
                    <iframe
                        width="100%"
                        height="250"
                        src={`https://www.youtube.com/embed/${video.youtube_id}`}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                    <p className='mb-3'>{video.title}</p>
                </div>
            ))}
        </div>
    );
};

export default VideoGallery;